import { initializeApp } from "firebase/app";
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyCNc9qFGsdsFk8aey1H3ifVR1zmXnFZ_1Q",
  authDomain: "quiz-7c366.firebaseapp.com",
  databaseURL: "https://quiz-7c366-default-rtdb.firebaseio.com",
  projectId: "quiz-7c366",
  storageBucket: "quiz-7c366.appspot.com",
  messagingSenderId: "587640996976",
  appId: "1:587640996976:web:c9355e54b1c76bb85ee0b5"
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);